import { EmployeeSize } from '@/assets/icons/filters';
import { TruncatedTextWithTooltip } from '@/ui/TooltipText';
import {
  Avatar,
  Box,
  Flex,
  Icon,
  Popover,
  PopoverBody,
  PopoverContent,
  PopoverTrigger,
  Text,
} from '@chakra-ui/react';
import { interviewTypeValueMap } from './schedule-interview/helpers';
import { useRef } from 'react';

export const ActivityPopover = ({ activity }) => {
  const ref = useRef(null);

  const { participants = [], interview_type = 'one_on_one' } = activity;

  return (
    <Box ref={ref}>
      <Popover trigger="hover">
        <PopoverTrigger>
          <Flex
            cursor="pointer"
            gap="5px"
            alignItems="center"
            width="fit-content"
          >
            <Icon as={EmployeeSize} width="14px" height="14px" />
            <TruncatedTextWithTooltip
              size="sm-medium"
              text={participants?.length}
              maxW="50px"
            />
          </Flex>
        </PopoverTrigger>
        <PopoverContent maxH="250px" p="12px" overflowY="auto" maxW="250px">
          <PopoverBody>
            <Flex flexDir="column">
              <Text size="sm-semi-bold" mb="6px">
                Type
              </Text>
              <Text size="sm-medium" mb="12px">
                {interviewTypeValueMap?.[interview_type] || 'Not configured'}
              </Text>
              <Text size="sm-semi-bold" mb="6px">
                Interviewers
              </Text>
              {participants?.length > 0 ? (
                <>
                  <Flex gap="12px" flexDir="column">
                    {participants?.map((interviewer) => {
                      return (
                        <Flex key={interviewer?.id} gap="6px">
                          <Avatar
                            borderRadius="6px"
                            name={interviewer?.full_name}
                            src={interviewer?.avatar_url}
                            width="22px"
                            height="22px"
                            className="avatar-sm"
                          />
                          <TruncatedTextWithTooltip
                            fontSize="sm"
                            text={interviewer?.full_name}
                          />
                        </Flex>
                      );
                    })}
                  </Flex>
                  {interview_type === 'one_on_one' && participants?.length > 1 && (
                    <Text
                      p="12px"
                      mt="12px"
                      mx="-12px"
                      background="ats-bg-primary"
                      borderRadius="6px"
                      fontSize="sm"
                    >
                      <b>Note:</b> We will only select one of the users from the
                      list below depending on availability.
                    </Text>
                  )}
                </>
              ) : (
                <Text fontSize="sm">No interviewer added</Text>
              )}
            </Flex>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    </Box>
  );
};
